import request from '../../../../request/request';

const getDeletedUsers = () => {
  return request({
    url: '/webapi/user/report/deleted-user'
  });
};

// eslint-disable-next-line import/prefer-default-export
export { getDeletedUsers };
